import axios from 'axios'

const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export const mailboxDelegationsUrl = (customerId, employeeId) =>
  `${ROOT}/customer/${customerId}/employee/${employeeId}/mailbox-delegations`

export function getMailboxDelegations({ customerId, employeeId }) {
  return axios.get(mailboxDelegationsUrl(customerId, employeeId))
}

export function updateMailboxDelegation({ customerId, employeeId, right, action, trusteeEmployeeId, trusteeIdentity }) {
  return axios.post(mailboxDelegationsUrl(customerId, employeeId), {
    right,
    action,
    trusteeEmployeeId,
    trusteeIdentity,
  })
}
